import React, { useEffect, useState } from "react";
import Loader from "../../../../../settings/loader";
import Window from "../../../../elements/window";
import Slide1 from "./slides/slide1";

const DetailedDiscountSummary = ({ user, chimeraserv, filter }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [forceReload, setForceReload] = useState(0);

  useEffect(() => {
    async function fetchDetails() {
      setLoading(true);
      let { base64 } = filter;
      base64 = JSON.parse(atob(base64));
      delete base64.revCent;
      base64 = btoa(JSON.stringify(base64));
      try {
        const response = await fetch(`${chimeraserv.urlGet}/discount/set/0/`, {
          method: "POST",
          body: JSON.stringify({ id: base64 }),
          headers: {
            Authorization: user.data.usrKey,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        const result = await response.json();

        setData(result);
      } catch (error) {
        console.error("Failed to fetch discount details.", error);
        setData([]);
      }
      setLoading(false);
    }
    fetchDetails();
  }, [user, chimeraserv, filter, forceReload]);

  const handleForceReload = () => {
    setForceReload((prev) => prev + 1);
  };

  return (
    <div className="custForm">
      {/* <div className="viewTitle">Detailed Discount Summary</div> */}
      {loading ? (
        <Loader />
      ) : (
        <Window
          user={user}
          chimeraserv={chimeraserv}
          title={"Detailed Discount"}
        >
          <Slide1
            user={user}
            chimeraserv={chimeraserv}
            filter={filter}
            data={data}
          />
        </Window>
        // <table className="table table-striped defaultTable">
        //   <thead>
        //     <tr>
        //       <th>Date</th>
        //       <th>Time</th>
        //       <th>Bill No</th>
        //       <th>Qty</th>
        //       <th>Item</th>
        //       <th>Price</th>
        //       <th>Raw Price</th>
        //       <th>Difference</th>
        //       <th>Discount Name</th>
        //       <th>Type</th>
        //     </tr>
        //   </thead>
        //   <tbody>
        //     {data.length === 0 ? (
        //       <tr>
        //         <td colSpan={10} style={{ textAlign: "center" }}>
        //           No discount details found.
        //         </td>
        //       </tr>
        //     ) : (
        //       data.map((row, idx) => (
        //         <tr key={idx}>
        //           <td>{row.date}</td>
        //           <td>{row.time}</td>
        //           <td>{row.billNo}</td>
        //           <td>{row.qty}</td>
        //           <td>{row.item}</td>
        //           <td>{row.price}</td>
        //           <td>{row.rawPrice}</td>
        //           <td>{row.difference}</td>
        //           <td>{row.discountName}</td>
        //           <td>
        //             {row.type === "item"
        //               ? "Item"
        //               : row.type === "order"
        //               ? "Order"
        //               : row.type}
        //           </td>
        //         </tr>
        //       ))
        //     )}
        //   </tbody>
        // </table>
      )}
    </div>
  );
};

export default DetailedDiscountSummary;
